import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useAddressesContext } from '../../AddressesContext';
import EnterAddress from '../../../../views/EnterAddress/EnterAddress';
import { Button, BUTTON_TYPE } from '../../../Button';
import ArrowBack from '../../../../images/circle-arrow-left-gray.svg';
import './AddressEdit.scss';

const AddressEdit = () => {
  const {
    editingAddress,
    navigateToList,
    handleSaveAddress,
    addressFormSubmitButtonText,
    newAddressFormTitle,
    designSystemForms,
    onValidAddressChange,
    hideAddressFormBackLink,
  } = useAddressesContext();

  const title = useMemo(
    () => (editingAddress ? 'Edit Address' : newAddressFormTitle),
    [editingAddress, newAddressFormTitle],
  );

  const handleAddressSave = async (addressData) => {
    await handleSaveAddress(addressData);
  };

  return (
    <div className={classNames('AddressEdit', { 'AddressEdit--formsDs20': designSystemForms })}>
      {!hideAddressFormBackLink && (
        <div className="AddressEdit__header">
          <Button
            type={BUTTON_TYPE.LINK}
            onClick={navigateToList}
            className="AddressEdit__back-button"
          >
            <img src={ArrowBack} alt="arrow-back" />
            Back to Delivery Addresses
          </Button>
        </div>
      )}
      <div className="AddressEdit__content">
        <h2 className="AddressEdit__title">{title}</h2>
        <EnterAddress
          addressSelected={editingAddress || {}}
          setFromAddress={handleAddressSave}
          submitButtonText={addressFormSubmitButtonText}
          variant={designSystemForms ? 'ds20' : 'default'}
          onValidAddressChange={onValidAddressChange}
        />
      </div>
    </div>
  );
};

export default AddressEdit;
